/*!
 * Dalafisk – cart panel behaviour
 * ------------------------------------------------------------------
 * Two things the design's cart does that Pinnacle's drawer does not:
 *   1. the tools pill becomes the panel's top row while it is open
 *      ([data-dalafisk-cart] on the header, read by dalafisk-cart.css)
 *   2. dots that fly from the add-to-cart button into the cart icon,
 *      with the count badge popping and the icon jolting
 *
 * The panel has no close button of its own (removed at the user's request); it
 * closes on the pill's cart icon, on ESC and on an outside click, all Pinnacle's.
 *
 * It also takes the design's body lock while it is open, so the page cannot
 * scroll out from under a panel that is pinned to the header.
 *
 * Nothing here owns cart STATE. Opening, closing, quantity updates and the
 * section re-render all stay in Pinnacle's <cart-drawer> element (app.js).
 * This script only observes it and decorates.
 *
 * Progressive: with the script absent the panel still opens, closes on the
 * pill's cart icon, on ESC and on an outside click, and the cart works fully.
 * Only the pill's corner treatment and the motion are lost.
 */
(function () {
  'use strict';

  if (window.__dalafiskCart) return;
  window.__dalafiskCart = true;

  var CART_OPEN = 'data-dalafisk-cart';
  var LOCK = 'dalafisk-cart-locked';
  var FLIGHT_MS = 560;

  function init() {
    var header = document.querySelector('.header.customHeaderStyle');
    var drawer = document.querySelector('cart-drawer');
    if (!header || !drawer) return;

    /* ---------- 1. open-state flag ----------
       app.js toggles the `inert` attribute and calls close() directly in
       several places, and only OPENING dispatches an event — so the attribute
       is the one signal that is true for every path in and out. */
    function syncOpenState() {
      var open = !drawer.hasAttribute('inert');
      if (open) header.setAttribute(CART_OPEN, '');
      else header.removeAttribute(CART_OPEN);
      /* The design's body lock. Its own class, not Pinnacle's
         `body.overflow-hidden`: that one belongs to the mobile menu, and
         header.js clears it on every menu close — closing the menu while the
         cart was open would have unlocked the page under it. */
      document.body.classList.toggle(LOCK, open);
    }
    new MutationObserver(syncOpenState).observe(drawer, {
      attributes: true,
      attributeFilter: ['inert']
    });
    syncOpenState();

    /* ---------- 2. add-to-cart motion ----------
       `cart:item-added` (app.js) says an add succeeded but not what was
       clicked, so the origin is the last add-to-cart control the visitor
       pressed. Captured on the way down so it is recorded even if the handler
       stops propagation. */
    var lastAddButton = null;
    document.addEventListener('click', function (e) {
      var t = e.target.closest
        ? e.target.closest('.product-card--add-to-cart-button-simple, [name="add"], .dalafisk-product-card__add, [data-dalafisk-add]')
        : null;
      if (t) lastAddButton = t;
    }, true);

    function cartIcon() {
      var icons = document.querySelectorAll('.thb-secondary-cart');
      for (var i = 0; i < icons.length; i++) {
        /* offsetParent is null for the copy inside a hidden breakpoint's header */
        if (icons[i].offsetParent) return icons[i];
      }
      return null;
    }

    var reduceMotion = window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function popBadge(icon) {
      var badge = icon.querySelector('.thb-secondary-area--item-count');
      if (!badge) return;
      badge.classList.add('dalafisk-cart-pop');
      setTimeout(function () { badge.classList.remove('dalafisk-cart-pop'); }, 220);
    }

    function flyToCart(from) {
      var target = cartIcon();
      if (!target) return;
      popBadge(target);
      if (!from || reduceMotion || !document.body.animate) return;

      var a = from.getBoundingClientRect();
      var b = target.getBoundingClientRect();
      if (!a.width || !b.width) return;

      var x0 = a.left + a.width / 2;
      var y0 = a.top + a.height / 2;
      var x1 = b.left + b.width / 2;
      var y1 = b.top + b.height / 2;

      for (var n = 0; n < 3; n++) {
        (function (n) {
          /* a control point above the path bends the flight into an arc */
          var cx = (x0 + x1) / 2 + (n - 1) * 46;
          var cy = Math.min(y0, y1) - 110 - n * 26;

          var dot = document.createElement('span');
          dot.className = 'dalafisk-cart-fly';
          dot.style.left = x0 + 'px';
          dot.style.top = y0 + 'px';
          document.body.appendChild(dot);

          var frames = [];
          for (var s = 0; s <= 24; s++) {
            var t = Math.pow(s / 24, 1.45);
            var u = 1 - t;
            var x = u * u * x0 + 2 * u * t * cx + t * t * x1;
            var y = u * u * y0 + 2 * u * t * cy + t * t * y1;
            frames.push({
              transform: 'translate(' + (x - x0) + 'px,' + (y - y0) + 'px) scale(' + (1 - 0.6 * t) + ')',
              opacity: t < 0.08 ? String(t / 0.08) : (t > 0.88 ? String((1 - t) / 0.12) : '1')
            });
          }

          var duration = FLIGHT_MS + n * 70;
          var anim = dot.animate(frames, { duration: duration, easing: 'linear', fill: 'forwards' });
          /* the timer also clears up when the tab is backgrounded and the
             animation never reaches onfinish */
          var sweep = setTimeout(function () { dot.remove(); }, duration + 900);
          anim.onfinish = function () { clearTimeout(sweep); dot.remove(); };

          if (n === 0) {
            setTimeout(function () {
              target.classList.add('dalafisk-cart-hit');
              setTimeout(function () { target.classList.remove('dalafisk-cart-hit'); }, 360);
            }, duration - 120);
          }
        }(n));
      }
    }

    document.addEventListener('cart:item-added', function () {
      flyToCart(lastAddButton);
      lastAddButton = null;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
